wbApp.controller('ClassroomsDetailCtrl', ['$scope', 'classroomSvc', 'geoCoderSvc', 'tenantSettingSvc', '$translate', '$filter',
function ($scope, classroomSvc, geoCoderSvc, tenantSettingSvc, $translate, $filter) {
    //var $hideImpl = $scope.$hide;

    //$scope.$hide = function () {
    //    $hideImpl();
    //    $scope.$destroy();
    //    console.log('scope destroyed');
    //}


    $scope.modelOrig = angular.copy($scope.model);

    $scope.detailTabs = [
        {
            title: 'TXT_MAIN',
            template: "setting/classrooms/classrooms-detail-main-tab.html",
            type: 'main'
        },
        {
            title: "TXT_LBL_ADDRESS",
            template: "setting/classrooms/classrooms-detail-address-tab.html",
            type: 'address'
        }
    ];

    if (tenantSettingSvc.settings.enableReservationSupport) {
        $scope.detailTabs.push({
            title: "TXT_SPECIALIZATIONS",
            template: "setting/classrooms/classrooms-detail-domains-tab.html",
            type: 'domains'
        });
        $scope.detailTabs.push({
            title: "TXT_RESERVATIONS_SETTINGS",
            template: "setting/classrooms/classrooms-detail-reservations-settings-tab.html",
            type: 'reservations-settings'
        });        
    }

    $scope.detailTabs.activeTab = 0;

    var domainsInitialized = false;

    $scope.classroomDomains = null;

    var treeListInstance = null;
    $scope.domainsOptions = {
        bindingOptions: {
            dataSource: 'classroomDomains',
        },
        height: 400,
        keyExpr: 'id',
        selection: {
            mode: 'multiple',
            recursive: false
        },
        editing: {
            allowUpdating: function(options) {
                if (!!options.row) {
                    return options.row.isSelected;
                } 
                return false;
            },
            mode: "cell"
        },
        showRowLines: true,
        allowColumnResizing: true,
        autoExpandAll: true,
        columns: [{
            caption: $translate.instant('TXT_LBL_NAME'),
            dataField: 'name',
            dataType: 'string',
            width: '220px',
            sortOrder: 'asc',
            allowEditing: false
        }, {
            caption: $translate.instant('TXT_LBL_DESCRIPTION'),
            dataField: 'description',
            dataType: 'string',
            allowEditing: false
        }, {
            caption: $translate.instant('TXT_RESERVATION_TEACHER_HOUR_SINGLE_RATE'),
            dataField: 'reservationTeacherHourSingleRateOverride',
            dataType: 'number', 
            format: { type: 'currency', precision: 2 },
            allowEditing: true,
            width: '100px',
            calculateCellValue: function(e) {
                if (_.isNil(e.reservationTeacherHourSingleRateOverride)) {
                    return e.reservationTeacherHourSingleRate;
                }

                return e.reservationTeacherHourSingleRateOverride;
            }
        }, {
            caption: $translate.instant('TXT_RESERVATION_TEACHER_HOUR_GROUP_ONE_RATE'),
            dataField: 'reservationTeacherHourGroupOneRateOverride',
            dataType: 'number',
            format: {type: 'currency', precision: 2},
            allowEditing: true,
            width: '100px',
            calculateCellValue: function (e) {
                if (_.isNil(e.reservationTeacherHourGroupOneRateOverride)) {
                    return e.reservationTeacherHourGroupOneRate;
                }

                return e.reservationTeacherHourGroupOneRateOverride;
            }
        }, {
            caption: $translate.instant('TXT_RESERVATION_TEACHER_HOUR_GROUP_TWO_RATE'),
            dataField: 'reservationTeacherHourGroupTwoRateOverride',
            dataType: 'number',
            format: {type: 'currency', precision: 2},
            allowEditing: true,
            width: '100px',
            calculateCellValue: function (e) {
                if (_.isNil(e.reservationTeacherHourGroupTwoRateOverride)) {
                    return e.reservationTeacherHourGroupTwoRate;
                }

                return e.reservationTeacherHourGroupTwoRateOverride;
            }
        }],
        onContentReady: function (e) {
            treeListInstance = e.component;
            if (!!origDomainsSelected) {
                treeListInstance.selectRows(origDomainsSelected, false);
            }
        },
        onCellPrepared: function(e) {
            if (e.columnIndex === 2) {
                e.cellElement.mousemove(function () {
                    e.cellElement.attr('title', 
                        $translate.instant('TXT_RESERVATION_TEACHER_HOUR_SINGLE_RATE_DESC') + 
                        "\n" + 
                        $translate.instant('TXT_PRICE_FROM_SETTINGS') +
                        " " +
                        $filter('wbCurrencyFlt')(tenantSettingSvc.settings.reservationTeacherHourSingleRate)
                    );
                });
            }
            if (e.columnIndex === 3) {
                e.cellElement.mousemove(function () {
                    e.cellElement.attr('title', 
                        $translate.instant('TXT_RESERVATION_TEACHER_HOUR_GROUP_ONE_RATE_DESC') +
                        "\n" +
                        $translate.instant('TXT_PRICE_FROM_SETTINGS') +
                        " " +
                        $filter('wbCurrencyFlt')(tenantSettingSvc.settings.reservationTeacherHourGroupOneRate));
                });
            }
            if (e.columnIndex === 4) {
                e.cellElement.mousemove(function () {
                    e.cellElement.attr('title', $translate.instant('TXT_RESERVATION_TEACHER_HOUR_GROUP_TWO_RATE_DESC') +
                        "\n" +
                        $translate.instant('TXT_PRICE_FROM_SETTINGS') +
                        " " +
                        $filter('wbCurrencyFlt')(tenantSettingSvc.settings.reservationTeacherHourGroupTwoRate));
                });
            }
            
            if (e.rowType === "data" && e.columnIndex === 2) {
                if (_.isNil(e.data.reservationTeacherHourSingleRateOverride) && (!_.isNil(e.data.reservationTeacherHourSingleRate))) {
                    e.cellElement.addClass('text-muted');
                }
            }
            if (e.rowType === "data" && e.columnIndex === 3) {
                if (_.isNil(e.data.reservationTeacherHourGroupOneRateOverride) && !_.isNil(e.data.reservationTeacherHourGroupOneRate)) {
                    e.cellElement.addClass('text-muted');
                }
            }
            if (e.rowType === "data" && e.columnIndex === 4) {
                if (_.isNil(e.data.reservationTeacherHourGroupTwoRateOverride) && !_.isNil(e.data.reservationTeacherHourGroupTwoRate)) {
                    e.cellElement.addClass('text-muted');
                }
            }            
        },
        onSelectionChanged: function (e) {
            if (e.currentSelectedRowKeys.length === 1) {
                let obj = _.find(e.selectedRowsData, { id: e.currentSelectedRowKeys[0] });
                if (obj && obj.parentId) {
                    treeListInstance.selectRows(obj.parentId, true);
                }
            } else if (e.currentDeselectedRowKeys.length === 1) {
                let obj = _.find(e.selectedRowsData, { parentId: e.currentDeselectedRowKeys[0] });
                if (obj) {
                    treeListInstance.selectRows(e.currentDeselectedRowKeys[0], true);
                }
            }
        }
    };

    var origDomainsSelected = [];
    var originDomains = [];

    function loadDomainsData() {

        classroomSvc.loadDomainsData($scope.model.id).then(function (data) {
            $scope.classroomDomains = data.domains;
            originDomains = _.cloneDeep(data.domains);
            origDomainsSelected = data.selection;
            if (!!treeListInstance) {
                treeListInstance.selectRows(origDomainsSelected, false);
            }
            domainsInitialized = true;
        });
    }

    $scope.$watch('detailTabs.activeTab', function (newValue, oldValue) {
        $scope.$broadcast('activeTabChanged', { activeTab: newValue });

        if (newValue >= 0 && newValue < $scope.detailTabs.length) {
            var selectedTab = $scope.detailTabs[newValue];

            if (selectedTab.type == 'domains' && !domainsInitialized) {
                loadDomainsData();
            }
        }
    });

    function domainsAreUnchanged() {
        return !domainsInitialized || 
               !treeListInstance ||
            (_.isEqual(origDomainsSelected.sort(), treeListInstance.getSelectedRowKeys().sort()) &&
             _.isEqual(originDomains, $scope.classroomDomains));
               
    }

    function detailIsUnchanged(data) {
        return angular.equals(data, $scope.modelOrig);
    }

    $scope.detailIsUnchanged = function (data) {
        return detailIsUnchanged(data) && domainsAreUnchanged();
    };

    $scope.isSaving = false;

    $scope.onClassroomDetailSave = function (model) {

        if ($scope.isSaving) {
            return;
        }

        $scope.isSaving = true;

        function success() {
            $scope.isSaving = false;
            $scope.$hide();
        }

        function error(data) {
            $scope.isSaving = false;
            $scope.detailError = data;
        }

        if (!detailIsUnchanged($scope.model)) {

           
            if (!model.id) {
                classroomSvc.insert(model, function (data) {
                    if (!domainsAreUnchanged()) {
                        classroomSvc.saveDomainsData(
                            data.id,
                            $scope.classroomDomains,
                            origDomainsSelected,
                            treeListInstance.getSelectedRowKeys(),
                            success,
                            error);
                    } else {
                        success();
                    }
                }, error, $scope.collection);
            } else {
                classroomSvc.update(model, function () {
                    if (!domainsAreUnchanged()) {
                        classroomSvc.saveDomainsData(
                            $scope.model.id,
                            $scope.classroomDomains,
                            origDomainsSelected,
                            treeListInstance.getSelectedRowKeys(),
                            success,
                            error);
                    } else {
                        success();
                    }
                }, error, $scope.collection);
            }
        } else if (!domainsAreUnchanged()) {
            classroomSvc.saveDomainsData(
                $scope.model.id,
                $scope.classroomDomains,
                origDomainsSelected,
                treeListInstance.getSelectedRowKeys(),
                success,
                error);
        } else {
            success();
        }


    }

    $scope.getAddress = function (val) {
        var res = geoCoderSvc.geocode(val);
        return res;
    }


}]);
